import Vue from 'vue';
export const availability=Vue.observable({error:''});
let deadline=null,timer;
function check(){
  clearTimeout(timer);
  if(!deadline)return;
  const remaining=deadline-Date.now();
  if(remaining<=0){availability.error='El servicio de esta carta ha caducado. Contacta con el administrador.';return;}
  timer=setTimeout(check,Math.min(remaining,2147483647));
}
export function setAvailability(data){
  availability.error='';
  const remaining=Date.parse(data.licenseExpiresAt)-Date.parse(data.serverTime);
  deadline=Number.isFinite(remaining)?Date.now()+remaining:null;check();
}
export function unavailable(error){
  if(['PUBLICATION_DISABLED','LICENSE_EXPIRED','LICENSE_NOT_STARTED'].includes(error.response?.data?.code))availability.error=error.response.data.error;
}
document.addEventListener('visibilitychange',check);
